/* MODA product pages: option tiles with prices (A) + bed-size icons on mattresses and bedroom pages (D) + colour photo chips from variant images. */
(function(){
  var body=document.body; if(!body||!body.classList.contains('mpdp-on')) return;
  var isMat=body.classList.contains('mpdp-on--mattress')||body.classList.contains('mpdp-on--bed');
  var BED={'single':[22,38],'king single':[26,40],'double':[32,38],'queen':[36,40],'king':[40,40],'super king':[44,40],'california king':[44,44],'queen split':[36,40],'king split':[40,40],'super king split':[44,40]};
  function money(c){ return '$'+(c/100).toLocaleString('en-NZ',{minimumFractionDigits:(c%100?2:0),maximumFractionDigits:2}); }
  function init(form){
    var vj=form.querySelector('script.pr_variants_json'); if(!vj) return;
    var variants; try{ variants=JSON.parse(vj.textContent); }catch(e){ return; }
    if(!variants || variants.length<2) return;
    var opts=[].slice.call(form.querySelectorAll('[data-swatch-option]'));
    function imgFor(idx,v){ for(var i=0;i<variants.length;i++){ var va=variants[i], fi=va.featured_image; if(va.options[idx]===v && fi && fi.src) return fi.src; } return null; }
    opts.forEach(function(o,oi){
      var items=[].slice.call(o.querySelectorAll('.t4s-swatch__list [data-swatch-item]'));
      if(!items.length || items[0].getAttribute('style')) return; // colour/image swatches stay as they are
      o.classList.add('mpdp-opt');
      /* colour photo chips: only when the option looks like a colour and every value has its own variant image */
      var lab=(o.textContent||'').slice(0,40), chips=null;
      if(/colou?r|fabric|finish|shade/i.test(lab)){
        var srcs=items.map(function(it){ return imgFor(oi,it.getAttribute('data-value')); });
        var uniq=srcs.filter(function(x,i){ return x && srcs.indexOf(x)===i; });
        if(uniq.length===items.length) chips=srcs;
      }
      items.forEach(function(it){
        if(it.querySelector('.mpdp-sw-n')) return;
        var v=it.getAttribute('data-value'); it.textContent='';
        var n=document.createElement('span'); n.className='mpdp-sw-n'; n.textContent=v;
        var p=document.createElement('small'); p.className='mpdp-sw-p';
        if(isMat){
          var key=v.toLowerCase().trim(), b=BED[key];
          if(b){ var i=document.createElement('i'); i.className='mpdp-bed'; i.style.setProperty('--w',b[0]+'px'); i.style.setProperty('--h',b[1]+'px'); if(/split/.test(key)){ var sp=document.createElement('b'); sp.style.cssText='position:absolute;top:0;bottom:0;left:50%;border-left:1px solid currentColor'; i.appendChild(sp); } it.appendChild(i); o.classList.add('mpdp-opt--beds'); }
          else if(/base/i.test(v)){ var j=document.createElement('i'); j.className='mpdp-mb mpdp-mb--base'; it.appendChild(j); o.classList.add('mpdp-opt--pics'); }
          else if(/mattress/i.test(v)){ var k=document.createElement('i'); k.className='mpdp-mb'; it.appendChild(k); o.classList.add('mpdp-opt--pics'); }
        }
        if(chips){
          var c=document.createElement('i'), src=chips[items.indexOf(it)];
          if(src.indexOf('//')===0) src='https:'+src;
          c.style.cssText='display:block;flex:none;width:36px;height:36px;border-radius:3px;background:#eee center/cover no-repeat;box-shadow:inset 0 0 0 1px rgba(0,0,0,.1)';
          c.style.backgroundImage='url("'+src+(src.indexOf('?')>-1?'&':'?')+'width=120")';
          it.appendChild(c);
          it.style.setProperty('display','flex','important'); it.style.setProperty('flex-direction','row','important');
          it.style.setProperty('align-items','center','important'); it.style.setProperty('justify-content','flex-start','important');
          it.style.setProperty('gap','12px','important'); it.style.setProperty('text-align','left','important');
          it.style.setProperty('padding-left','12px','important');
        }
        var t=document.createElement('span'); t.className='mpdp-sw-t'; t.appendChild(n); t.appendChild(p); it.appendChild(t);
        if(chips){ t.style.setProperty('align-items','flex-start','important'); }
      });
    });
    function selected(){
      return opts.map(function(o){ var s=o.querySelector('[data-swatch-item].is--selected'); return s?s.getAttribute('data-value'):null; });
    }
    function update(){
      var sel=selected();
      opts.forEach(function(o,idx){
        if(!o.classList.contains('mpdp-opt')) return;
        var others=sel.map(function(s,i){ return i===idx?null:s; });
        var allOthers=others.every(function(s,i){ return i===idx||s!==null; });
        var items=[].slice.call(o.querySelectorAll('.t4s-swatch__list [data-swatch-item]'));
        var prices=items.map(function(it){
          var v=it.getAttribute('data-value'), min=null, max=null;
          variants.forEach(function(va){
            if(va.options[idx]!==v) return;
            for(var i=0;i<others.length;i++){ if(others[i]!==null && va.options[i]!==others[i]) return; }
            if(min===null||va.price<min) min=va.price; if(max===null||va.price>max) max=va.price;
          });
          return [min,max];
        });
        var base=null; prices.forEach(function(p){ if(p[0]!==null&&(base===null||p[0]<base)) base=p[0]; });
        var showDiff = allOthers && idx>0;
        items.forEach(function(it,k){
          var el=it.querySelector('.mpdp-sw-p'); if(!el) return; var p=prices[k];
          if(p[0]===null){ el.textContent=''; return; }
          if(showDiff && p[0]!==base){ el.textContent='+ '+money(p[0]-base); }
          else if(p[0]!==p[1]){ el.textContent='from '+money(p[0]); }
          else { el.textContent=money(p[0]); }
        });
      });
    }
    update();
    form.addEventListener('click',function(e){ if(e.target.closest('[data-swatch-item]')) setTimeout(update,60); });
    if(window.jQuery){ window.jQuery(form.closest('[data-product-featured]')||document).on('variant:changed',function(){ setTimeout(update,30); }); }
  }
  function boot(){ var f=document.querySelector('[data-product-featured]'); if(f) init(f); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();

  /* phone gallery: "1 / N" counter + dots (peek is CSS) */
  function gallery(){
    var grp=document.querySelector('[data-product-single-media-group]'); if(!grp) return;
    var main=grp.querySelector('[data-main-media]'); if(!main) return;
    function slides(){ return [].slice.call(main.querySelectorAll('[data-main-slide]')).filter(function(s){ return !s.classList.contains('is--media-hide'); }); }
    if(slides().length<2) return;
    var pill=document.createElement('span'); pill.className='mpdp-count'; grp.appendChild(pill);
    var dots=document.createElement('div'); dots.className='mpdp-dots'; grp.appendChild(dots);
    function paint(){
      var s=slides(), n=s.length, i=0;
      s.forEach(function(el,k){ if(el.classList.contains('is-selected')) i=k; });
      pill.textContent=(i+1)+' / '+n;
      if(dots.children.length!==n){ dots.innerHTML=''; for(var k=0;k<n;k++){ dots.appendChild(document.createElement('span')); } }
      [].forEach.call(dots.children,function(d,k){ d.classList.toggle('is-on',k===i); });
      var show=n>1; pill.style.display=dots.style.display=show?'':'none';
    }
    paint();
    new MutationObserver(function(){ clearTimeout(gallery._t); gallery._t=setTimeout(paint,40); }).observe(main,{subtree:true,attributes:true,attributeFilter:['class']});
    window.addEventListener('resize',function(){ setTimeout(paint,100); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',gallery); else gallery();
})();
